module.exports = __webpack_public_path__ + "static/media/21ECLAC50.e8aa963f.jpg";